import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';

export default function OverviewNavButton(props) {
  const {
    triggered,
    onTrigger,
  } = useNavAction('Overview', props);

  return (
    <FocusableButton {...ex(['NavButton', 'OverviewNavButton', { triggered }], props)} {...{ onClick: onTrigger() }}>
      <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_76_936)">
          <path d="M23 7H9C7.9 7 7 7.9 7 9V23C7 24.1 7.9 25 9 25H23C24.1 25 25 24.1 25 23V9C25 7.9 24.1 7 23 7ZM23 23H9V9H23V23ZM11 14H13V21H11V14ZM15 11H17V21H15V11ZM19 17H21V21H19V17Z" />
        </g>
        <defs>
          <clipPath id="clip0_76_936">
            <rect width={24} height={24} fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
      {T('Overview')}
    </FocusableButton>
  );
}
